import React from "react";
import ReactDOM from "react-dom/client";
import Hub from './index.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Hub />);